var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "lg" } },
        [
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _c("img", {
              staticClass: "mb-4 logo",
              attrs: { src: require("img/logos/RGB_OPENSALUD_AZUL.svg") }
            }),
            _c("br")
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    {
                      attrs: {
                        href:
                          "https://localhost:8080/es/professional/es-nodofarma-list"
                      }
                    },
                    [_vm._v("Test de video")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      attrs: {
                        href:
                          "https://localhost:8080/es/professional/es-nodofarma"
                      }
                    },
                    [_vm._v("Cuadro de mando")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    { attrs: { text: "Español", right: "" } },
                    [
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Español")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Ingles")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Catalan")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("em", [
                                _vm._v("Dr. Francisco Luis Velasco Reina")
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Configurar")
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { href: "#" } }, [
                        _vm._v("Salir")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            {
              staticClass: "vh-50 mx-auto text-center",
              attrs: { "align-v": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-tabs",
                    { attrs: { fill: "" } },
                    [
                      _c("b-tab", {
                        attrs: {
                          title: "Mi perfil",
                          active: _vm.activeTab == "profile"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mis servicios",
                          active: _vm.activeTab == "services"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Chats",
                          active: _vm.activeTab == "chats"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mis consultas",
                          active: _vm.activeTab == "appointments"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Solicitudes de cita",
                          active: _vm.activeTab == "requests"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mi agenda",
                          active: _vm.activeTab == "scheduler"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: {
                          title: "Mis pacientes",
                          active: _vm.activeTab == "patients"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c37ff40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c37ff40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/professional/customHeader.vue
// module id = 1684
// module chunks = 116